<template>
  <div id="app">
    <b-container class="mt-4">
      <b-img center src="https://storage.googleapis.com/congresoqroo/static/img/logo-legislatura-actual.svg" class="logo-legislatura" alt="Logo XVI Legislatura del Estado de Quintana Roo."></b-img>
      <div class="text-center my-5">
        <h1>Paquete Fiscal</h1>
        <h6>La XVI Legislatura del H. Congreso del Estado de Quintana Roo presenta <br>el paquete Económico Fiscal</h6>
      </div>
      <template v-for="paquete in paquete_fiscal">        
          <b-card no-body>
            <b-card-header header-tag="header" role="tab">
              <b-button block href="#" v-b-toggle="paquete.anio" >{{paquete.anio}}</b-button>
            </b-card-header>
            <b-collapse  visible v-bind:id="paquete.anio" accordion="my-accordion" role="tabpanel">              
                <b-card-body>
                    <template v-for="ley in paquete.leyes" v-if="ley.tipo == 'ley'">
                      <b-card-text>                         
                          <span class="text-02" v-b-tooltip.hover title="Publicación en el periódico oficial"><strong>P.P.O. {{ley.fecha}}</strong></span><br>                    
                          <a v-bind:href="ley.link" class="text-01" target="_black">{{ley.nombre}}</a>                        
                      </b-card-text>
                    </template>
                    <hr>
                    <h5 class="mt-5">TABLA DE VALORES</h5>
                    <template v-for="ley in paquete.leyes" v-if="ley.tipo == 'decreto'">
                      <b-card-text>                          
                          <span class="text-02" v-b-tooltip.hover title="Publicación en el periódico oficial"><strong>P.P.O. {{ley.fecha}}</strong></span><br>                    
                          <a v-bind:href="ley.link" class="text-01" target="_black">{{ley.nombre}}</a>                        
                      </b-card-text>
                    </template>                  
                </b-card-body>              
            </b-collapse>              
          </b-card>               
        
      </template>

      
    </b-container>
    <div class="btn-index">
     <b-link href="https://congresoqroo.gob.mx/" v-b-tooltip.hover title="Regresar a la página principal"><b-icon-house></b-icon-house></b-link>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      paquete_fiscal: [
        /*{
          anio: '2019',
          leyes:[
            {
              nombre: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia natus iure tempora necessitatibus, excepturi, velit, quia eligendi corrupti laboriosam doloribus rerum quisquam sapiente exercitationem ut quibusdam maiores magnam, praesentium totam.',
              link:'vinculo 1',
              fecha: 'Marzo 22, 2019',
              //anio:'2019',
            },            
          ]
        },*/
        {
          anio: 'Ejercicio 2020',
          leyes:[
            {
              nombre: 'Ley de Hacienda del Municipio de Benito Juárez, del Estado de Quintana Roo. ',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L139-XVI-20191227-L1620191227006.pdf',
              fecha: 'Dic 27, 2019', 
              tipo: 'ley',             
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Puerto Morelos.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L170-XV-31122018-771.pdf',
              fecha: 'Dic 31, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Hacienda del Municipio de Isla Mujeres, del Estado de Quintana Roo. ',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L193-XVI-20191227-L1620191227010.pdf',
              fecha: 'Dic. 27, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Derechos del Estado de Quintana Roo.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L195-XVI-20191218-L1620191218011.pdf',
              fecha: 'Dic. 18, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Hacienda del Estado de Quintana Roo.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L218-XVI-20191218-L1620191218012.pdf',
              fecha: 'Dic. 18, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley del Impuesto al Hospedaje del Estado de Quintana Roo.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L187-XVI-20191230-L1620191230013.pdf',
              fecha: 'Dic. 30, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Código Fiscal del Estado de Quintana Roo.',
              link:'http://documentos.congresoqroo.gob.mx/codigos/C5-XVI-27122019-C1620191227014.pdf',
              fecha: 'Dic. 27, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L219-XVI-20191227-L1620191227015-ingresos.pdf',
              fecha: 'Dic. 27, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Presupuesto de Egresos del Gobierno del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L220-XVI-20191220-L1620191220016-egresos.pdf',
              fecha: 'Dic. 20, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Hacienda del Municipio de Cozumel, del Estado de Quintana Roo.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L96-XV-20190315-L1520190315305.pdf',
              fecha: 'Marzo 15, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Hacienda del Municipio de Tulum, del Estado de Quintana Roo.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L141-XVI-20191227-L1620191213023.pdf',
              fecha: 'Dic. 27, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Cozumel, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L208-XVI-20191226-L1620191226024.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Benito Juárez, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L209-XVI-20191226-L1620191226025.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Tulum, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L210-XVI-20191226-L1620191226027.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Bacalar, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L211-XVI-20191226-L1620191226027.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de José María Morelos, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L212-XVI-20191226-L1620191226028.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Lázaro Cárdenas, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L213-XVI-20191226-L1620191226029.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Felipe Carrillo Puerto, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L214-XVI-20191226-L1620191226030.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Othón P. Blanco, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L215-XVI-20191226-L1620191226031.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Isla Mujeres, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L216-XVI-20191226-L1620191226032.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Hacienda del Municipio de Solidaridad del Estado de Quintana Roo.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L140-XVI-20191227-L1620191227034.pdf',
              fecha: 'Dic. 27, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Ley de Ingresos del Municipio de Solidaridad, del Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/leyes/L217-XVI-20191226-L1620191226035.pdf',
              fecha: 'Dic. 26, 2019',
              tipo: 'ley',              
            },
            {
              nombre: 'Decreto 7, por el que se aprueban las Tablas de valores unitarios de suelo y construcciones, que servirán de base para el cobro de las contribuciones sobre la propiedad inmobiliaria en el municipio de Benito Juarez, Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/decretos/EXVI-2019-12-10-7.pdf',
              fecha: 'Dic. 27, 2019',  
              tipo: 'decreto',            
            },
            {
              nombre: 'Decreto 21, por el que se aprueban las Tablas de Valores Unitarios de Suelo y Construcciones que servirán de base para el cobro de las contribuciones sobre la propiedad inmobiliaria en el Municipio de Cozumel, Estado de Quintana Roo, para el ejercicio fiscal 2020.',
              link:'http://documentos.congresoqroo.gob.mx/decretos/EXVI-2019-12-13-21.pdf',
              fecha: 'Dic. 27, 2019',
              tipo: 'decreto',            
            },           
          ]
        },
      ]
    }
  },
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Montserrat:400,600,700,800|Oswald:200,300,400,500,600&display=swap');

  $color-01: #4a4d55; /*gris obscuro*/
  $color-02: #e2e2e2; /*gris bajo*/
  $color-03: #A29E9E; /*gris medio*/
  $font-01: 'Montserrat', sans-serif;
  $font-02: 'Oswald', sans-serif;
  
  
  body{
    color: $color-01;    
    background-image: url(img/fondo-body.svg);
    background-repeat: no-repeat;
    background-size: contain;
    height: 100vh;
  }
  .container{
    padding-bottom: 50px;
  }
  h1{
    text-transform: uppercase;
    font-family: $font-01;
    font-weight: 600;
  }
  h6{
    color: $color-03;
    font-family: $font-02;
    font-weight: 300;
  }
  .logo-legislatura{
    width: 200px;    
  }
  .card{
    border: 0;
    border-radius: 0;
  }
  .card-header{
    padding:0;
  }
  .btn{
    text-align:left;
  }
  .btn-secondary{
    background-color: $color-01;
    color: white;
    font-family: $font-01;
    font-weight: 600;
    font-size: 1.5rem;
    border-radius: 0;
    border: 0;
    &:hover,
    &:focus{
      background-color:$color-02;
      color: $color-01;
    }      
  }
  .text-01{
    font-family: $font-02;
    font-weight: 500;
    font-size: 1.1rem;
    color: $color-01;
    &:hover,
    &:focus{
      text-decoration: none;
      color: grey;    
    }    
  }
  .text-02{
    font-family: $font-02;
    font-weight: 200;
    color: $color-03;
    font-size: 0.85rem;
  }
  .btn-index{
  background-color: white;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  padding: 5px;
  position: fixed;
  bottom: 20px;
  right: 80px;
  display:flex;
  justify-content:center;
  align-items: center;
  a{    
    margin: 20px;
    color: $color-01;
    font-size: 50px;    
  }
  &:hover{
    background-color: grey;
    a{
      color: white;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/App.vue